module.exports = __webpack_public_path__ + "media/images/bnr_amazon_sp-7ec594a0efe674a08e4a9e2f9baffc30.png";